<template>
  <a-modal
    class="material-bg-remover material-color-picker--filled"
    :visible="visible"
    @cancel="handleCancel"
    width="800px"
    title="绿幕抠图"
    :maskClosable="false"
    centered
  >
    <canvas ref="canvas" v-show="false" />
    <canvas
      ref="otherCanvas"
      class="material-color-picker__canvas material-bg-remover__canvas"
      :class="{ 'material-bg-remover__canvas--full': previewing }"
      @mousemove="handleMouseMove"
      @mouseleave="handleMouseLeave"
      @click="handleClick"
      :style="{
        cursor: previewing ? 'default' : 'crosshair'
      }"
      v-show="drawn"
    />
    <span
      class="material-color-picker__title"
      v-if="position && !previewing"
      :style="{ top: position.y + 'px', left: position.x + 'px' }"
    >
      <span
        class="material-color-picker__preview"
        :style="{ backgroundColor: displayColor }"
      ></span>
      {{ displayColor }}
    </span>
    <div
      class="material-bg-remover__actions"
      :class="{ 'material-bg-remover__actions--hidden': previewing }"
    >
      <a-row type="flex" align="middle">
        <color-gradient-editor
          :gradient="false"
          hidePicker
          hideTypes
          popperClass="aa"
          ref="colorEditor"
          label="选择颜色"
          v-model="displaySelected"
          @change="handleColorChange"
        />
        <el-tooltip content="切换颜色编辑">
          <a-button
            @click="togglePick"
            :class="picking ? 'ant-btn-primary' : 'ant-btn-link'"
            shape="circle"
            size="small"
            class="ant-btn-icon-only"
          >
            <a-icon type="edit" />
          </a-button>
        </el-tooltip>
        <span style="margin-left: 14px">
          {{
            picking && selected
              ? "颜色选区编辑中"
              : "提示：请使用鼠标十字光标在所选图片上添加抠图区域。"
          }}
        </span>
      </a-row>
      <label-slider
        useModel
        :min="0"
        :max="120"
        v-model="dist"
        label="容差"
        class="material-bg-remover__row"
      />
      <a-row class="material-bg-remover__row" :gutter="24" type="flex">
        <a-col flex="1">
          <label-slider
            useModel
            :min="0"
            :max="10"
            :step="0.5"
            v-model="blur"
            label="边缘羽化"
          />
        </a-col>
        <a-col>
          <a-checkbox v-model="previewBlur">边缘羽化预览</a-checkbox>
        </a-col>
      </a-row>
    </div>
    <a-row slot="footer" type="flex" align="middle">
      <a-col flex="1">
        <a-button v-if="previewing" @click="prev">编辑</a-button>
        <!-- 提示：请使用鼠标十字光标在所选素材上点击拾取颜色。 -->
        <span
          class="material-bg-remover__indicator"
          :class="{ 'material-bg-remover__indicator--hidden': !filterLoading }"
        >
          <a-icon type="loading" />
          图片数据处理中
        </span>
      </a-col>
      <template v-if="previewing">
        <a-checkbox v-model="addToLib" style="margin-right: 12px">
          同时添加至我的素材
        </a-checkbox>
        <a-button type="primary" @click="done" :loading="loading">
          完成
        </a-button>
      </template>
      <template v-else>
        <!-- <a-select
          v-model="activeCond"
          class="material-bg-remover__select"
          dropdownClassName="material-bg-remover__dropdown"
        >
          <a-select-option v-for="(item, i) in conds" :key="i" :value="i">
            <span
              class="material-color-picker__preview"
              :style="
                item.color
                  ? { backgroundColor: `rgb(${item.color.join(',')})` }
                  : {}
              "
            ></span>
            颜色选区 {{ i + 1 }}
          </a-select-option>
        </a-select> -->
        <a-button
          class="material-color-picker__footer-btn"
          @click="remove"
          :disabled="conds.length <= 1 && !selected"
        >
          上一步
        </a-button>
        <!-- <a-button
          class="material-color-picker__footer-btn"
          :disabled="conds.length > 9 || !canNext"
          @click="append"
        >
          继续
        </a-button> -->
        <div class="material-color-picker__footer-split" />
        <!-- <a-button :disabled="!canPreview" @click="next" :loading="loading">
          预览
        </a-button> -->
        <a-button
          type="primary"
          :disabled="!canPreview"
          @click="directDone"
          :loading="loading"
        >
          完成
        </a-button>
      </template>
    </a-row>
  </a-modal>
</template>
<script>
// import { mapGetters, mapState } from 'vuex';
import Color from 'element-ui/packages/color-picker/src/color';
import { Empty, message } from 'ant-design-vue';
import { encodeURIIfNeeded, getImageAspectRatio } from '../../utils';
import ColorGradientEditor from '../base/ColorGradientEditor';
import icons from '../material/materialTypeIcons';
import LabelSlider from '../base/LabelSlider';
import { post, uploadFile2 } from '../../utils/api';

function filterImage(data, conds, blur, width, height) {
  // process ImageData object
  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    conds.some(({ color, dist }) => {
      if (Math.pow(r - color[0], 2) + Math.pow(g - color[1], 2) + Math.pow(b - color[2], 2) <= Math.pow(dist, 2)) {
        data[i + 3] = 0;
        return true;
      }
      return false;
    });
  }

  if (conds.length && blur) { // only blur the alpha channel
    // get radius from sigma (?)
    let sigma = blur;
    const sq2pi = Math.sqrt(2 * Math.PI);
    let a = 1 / (2 * sigma * sigma);
    let b = 1 / (sq2pi * sigma);
    let w;
    for (w = 3; ; w += 2) {
      let norm = 0;
      const j = (w + 1) / 2;
      for (let i = -j; i <= j; i++) {
        norm += Math.exp(-i * i * a) * b;
      }
      const value = Math.exp(-j * j * a) * b / norm;
      console.log(value);
      if (value < 1 / 255) {
        break;
      }
    }
    const v = (w * 3 - 1) / 2;
    sigma *= 3;
    a = 1 / (2 * sigma * sigma);
    b = 1 / (sq2pi * sigma);
    const vals = [];
    for (let u = -v; u <= v; u++) {
      const index = Math.floor((u + v) / 3);
      vals[index] = vals[index] || 0;
      vals[index] += Math.exp(-u * u * a) * b;
    }
    const wt = vals.reduce((prev, cur) => prev + cur, 0);
    if (wt) {
      vals.forEach((_, i) => {
        vals[i] /= wt;
      });
    }
    const midIndex = Math.floor(vals.length / 2);
    console.log(vals);
    console.log(w);
    for (let i = 0; i < data.length; i += 4) {
      const px = i / 4;
      const x = px % width;
      let total = 0;
      vals.forEach((cv, k) => {
        let offset = k - midIndex;
        if (offset + x < 0) {
          offset = -x;
        }
        if (offset + x >= width) {
          offset = width - x - 1;
        }

        // shift by pixels
        total += cv * data[i + 4 * offset + 3];
      });

      data[i + 3] = total;
    }

    // second pass
    for (let i = 0; i < data.length; i += 4) {
      const px = i / 4;
      const y = Math.floor(px / width);
      let total = 0;
      vals.forEach((cv, k) => {
        let offset = k - midIndex;
        if (offset + y < 0) {
          offset = -y;
        }
        if (offset + y >= height) {
          offset = height - y - 1;
        }

        // shift by pixels
        total += cv * data[i + 4 * width * offset + 3];
      });

      data[i + 3] = total;
    }
  }
}
const scriptText = `var filterImage=${filterImage};this.onmessage=function(e){filterImage.apply(null,e.data);postMessage(e.data[0],{transfer:[e.data[0].buffer]})}`;
const currentWorker = new Worker(URL.createObjectURL(
  new Blob([scriptText], { type: 'application/javascript' })
));

export default {
  components: { ColorGradientEditor, LabelSlider },
  props: ['src', 'visible'],
  data() {
    return {
      position: null,
      color: null,
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
      picking: true,
      previewing: false,
      ColorPickerIcon: icons.effect,
      blur: 0,
      loading: false,
      conds: [
        {
          color: null,
          dist: 10
        }
      ],
      activeCond: 0,
      drawn: false,
      addToLib: false,
      filterLoading: false,
      previewBlur: false
    };
  },
  computed: {
    activeOption() {
      return this.visible ? encodeURIIfNeeded(this.src) : '';
    },
    displayColor() {
      if (this.color) {
        return '#' + this.color.map(n => {
          const s = n.toString(16);
          return n < 16 ? '0' + s : s;
        }).join('');
      }
      return '';
    },
    displaySelected: {
      get() {
        if (this.selected) {
          return '#' + this.selected.map(n => {
            const s = n.toString(16);
            return n < 16 ? '0' + s : s;
          }).join('');
        }
        return '';
      },
      set(value) {
        if (value) {
          const color = new Color();
          color.fromString(value);
          const { r, g, b } = color.toRgb();
          this.selected = [r, g, b];
        } else {
          this.selected = null;
        }
      }
    },
    highlightMarker() {
      return this.drawn && !this.previewing && (
        [].concat.apply(
          [this.previewBlur ? this.blur : 0, this.picking ? 'picking' : ''],
          this.conds.map(cd => [cd.color, cd.dist])
        ).join(',')
      );
    },
    selected: {
      get() {
        const cond = this.conds[this.activeCond];
        return cond.color;
      },
      set(value) {
        const cond = this.conds[this.activeCond];
        cond.color = value;
      }
    },
    dist: {
      get() {
        const cond = this.conds[this.activeCond];
        return cond.dist;
      },
      set(value) {
        const cond = this.conds[this.activeCond];
        cond.dist = value;
      }
    },
    usedConds() {
      return this.conds.filter((c, i) => {
        return !!c.color && (!this.picking || i !== this.activeCond);
      });
    },
    canNext() {
      return this.conds.every(c => !!c.color);
    },
    canPreview() {
      return this.conds.length === 1 ? this.conds[0].color : this.conds.slice(0, -1).every(c => !!c.color);
    }
  },
  methods: {
    togglePick() {
      this.picking = !this.picking;
    },
    handleColorChange() {
      this.picking = false;
    },
    handleMouseMove(e) {
      if (!this.previewing) {
        const canvas = this.$refs.canvas; // the hidden one that keeps original context
        const otherCanvas = this.$refs.otherCanvas; // the visible

        const bcr = otherCanvas.getBoundingClientRect();
        const parentBcr = otherCanvas.parentElement.getBoundingClientRect();
        const context = canvas.getContext('2d');

        const imgdata = context.getImageData(
          (e.clientX - bcr.left) * canvas.width / bcr.width,
          (e.clientY - bcr.top) * canvas.height / bcr.height,
          1, 1
        );
        const arr = [].slice.call(imgdata.data, 0, 3); // rgb only w/o alpha channel
        this.color = arr;
        this.position = {
          x: e.clientX - parentBcr.left,
          y: e.clientY - parentBcr.top
        };
      }
    },
    handleMouseLeave() {
      this.position = null;
    },
    handleClick() {
      if (!this.previewing) {
        if (!this.picking && this.selected) {
          this.append(); // append next color before setting
        }
        this.selected = this.color;
        this.picking = false;
      }
    },
    draw() {
      const canvas = this.$refs.canvas;

      if (!canvas) {
        this.$nextTick(this.draw);
        return;
      }

      getImageAspectRatio(this.activeOption, img => {
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const context = canvas.getContext('2d');
        context.save();
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(img, 0, 0);
        context.restore();

        this.drawn = true;
      }, true);
    },
    /**
     * @param{ImageData}imgData
     * @param{HTMLCanvasElement}canvas
     */
    copyImageData(imgData, canvas) {
      const otherCanvas = canvas || document.createElement('canvas');
      const { width: w, height: h } = imgData;
      otherCanvas.width = w;
      otherCanvas.height = h;
      const otherContext = otherCanvas.getContext('2d');
      if (imgData) {
        otherContext.putImageData(imgData, 0, 0);
      }
      return {
        canvas: otherCanvas,
        context: otherContext
      };
    },
    filterImage(imgData, conds, blur) {
      this.filterLoading = true;
      return new Promise(resolve => {
        currentWorker.onmessage = ({ data }) => {
          this.filterLoading = false;
          if (this.filterDone) {
            const ret = this.filterDone;
            this.filterDone = null;
            requestAnimationFrame(ret);
          }
          resolve(new ImageData(data, imgData.width, imgData.height));
        };
        currentWorker.postMessage([imgData.data, conds, blur, imgData.width, imgData.height], {
          transfer: [imgData.data.buffer]
        });
      });
    },
    async drawHighlight() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');

      // this is new
      const imgData = context.getImageData(0, 0, canvas.width, canvas.height);

      // one might be picking so current cond is not highlighted
      if (this.filterLoading) {
        this.filterDone = this.drawHighlight;
        return;
      }
      const filteredImgData = await this.filterImage(imgData, this.usedConds, this.previewBlur ? this.blur : 0);

      // a temp canvas to draw imgData on
      const { canvas: copyCanvas } = this.copyImageData(filteredImgData);

      const otherCanvas = this.$refs.otherCanvas;
      otherCanvas.width = canvas.width;
      otherCanvas.height = canvas.height;
      const otherContext = otherCanvas.getContext('2d');
      otherContext.save();
      otherContext.globalAlpha = .35;
      otherContext.clearRect(0, 0, canvas.width, canvas.height);
      // copy orig canvas
      otherContext.drawImage(canvas, 0, 0);
      otherContext.restore();
      otherContext.drawImage(copyCanvas, 0, 0);
    },
    async processNext() {
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');

      const imgData = context.getImageData(0, 0, canvas.width, canvas.height);
      const otherCanvas = this.$refs.otherCanvas;
      if (!this.selected) {
        this.conds.pop();
        this.activeCond = this.conds.length - 1;
      }
      if (this.filterLoading) {
        this.filterDone = this.processNext;
        return;
      }
      const filteredImgData = await this.filterImage(imgData, this.conds, this.blur);

      this.copyImageData(filteredImgData, otherCanvas);
    },
    next() {
      this.processNext();
      this.previewing = true;
      this.picking = false;
    },
    prev() {
      this.previewing = false;
      // this.picking = true;
    },
    append() {
      const len = this.conds.length;
      this.conds.push({
        color: null,
        dist: 10
      });
      this.activeCond = len;
      this.picking = true;
    },
    remove() {
      if (this.conds.length > 1) {
        this.conds.splice(this.activeCond, 1);
        if (this.activeCond >= this.conds.length) {
          this.activeCond--;
          this.picking = false;
        }
      } else {
        this.selected = null;
      }
    },
    done() {
      // this.$store.commit('handleMaterialColor', this.selected);
      // setTimeout(() => {
      //   this.visible = false;
      // }, 0);
      this.loading = true;
      const otherCanvas = this.$refs.otherCanvas;
      otherCanvas.toBlob(/**
      @param{Blob}blob */
        async (blob) => {
          blob.name = 'generated.png';
          const { url } = await uploadFile2(blob);
          // always add to lib as well
          const size = blob.size;
          if (size > 10 << 20) {
            message.warning({
              content: '图片大小超过 10M, 已停止添加至我的素材。',
              duration: 3
            });
          } else {
            const postData = {
              filename: 'generated.png',
              file_url: url,
              file_size: size
            };

            await post('add-material2', postData);
            message.success('图片已添加至我的素材，可在素材面板查看。');
            this.$store.state.uploadModalMarker++;
            this.$store.dispatch('getUploadSpace');
          }
          this.loading = false;
          this.$emit('done', url);
        }, 'image/png');
    },
    directDone() {
      this.processNext().then(this.done);
    },
    handleCancel() {
      this.$emit('update:visible', false);
    }
  },
  watch: {
    activeOption(val) {
      if (val) {
        this.draw();
      } else {
        this.drawn = false;
      }
    },
    visible(val) {
      if (val) {
        this.previewing = false;
        this.picking = true;
        this.blur = 1;
        this.conds = [{
          color: null,
          dist: 10
        }];
        this.activeCond = 0;
        this.loading = false;
      }
    },
    highlightMarker(val) {
      if (val) {
        this.drawHighlight();
      }
    }
  }
};
</script>
<style>
.material-bg-remover .ant-modal-body {
  overflow: hidden;
}

.material-bg-remover .ant-modal-footer {
  text-align: left;
}

.material-color-picker__canvas.material-bg-remover__canvas {
  cursor: default;
  background: #fff
    url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAyIDIiPjxwYXRoIGQ9Ik0wIDB2MWgydjFIMVYweiIgZmlsbD0icmdiYSgwLDAsMCwuMikiLz48L3N2Zz4=);
  background-size: 12px;
}

.material-color-picker__canvas.material-bg-remover__canvas--full {
  bottom: 0;
  max-height: 540px;
}

.material-bg-remover__actions {
  position: absolute;
  bottom: 0;
  height: 120px;
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
  overflow: hidden;
  padding: 12px 16px;
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.75);
}

.material-bg-remover__actions--hidden {
  transform: translate3d(0, 100%, 0);
  opacity: 0;
  visibility: hidden;
}

.material-bg-remover__actions .color-gradient-editor {
  margin: 0 18px 0 0;
}

.material-bg-remover__actions .color-gradient-editor__picker {
  margin-left: 8px;
}

.material-bg-remover__row {
  margin-top: 10px;
  align-items: center;
}

.material-bg-remover__actions .label-slider .label {
  width: 100px;
}

.material-bg-remover__actions .label-slider .setting-slider {
  flex-grow: 1;
  margin: 0 20px;
}

.material-bg-remover__select {
  width: 128px;
  margin-right: 14px;
}

.material-bg-remover__select .ant-select-selection__rendered {
  padding-left: 32px;
  margin-left: 0;
}

.material-bg-remover__dropdown .ant-select-dropdown-menu-item {
  padding-left: 32px;
}

.material-bg-remover__select .material-color-picker__preview,
.material-bg-remover__dropdown .material-color-picker__preview {
  width: 20px;
  height: 20px;
  left: 6px;
  margin-top: -10px;
}

.material-color-picker__footer-btn {
  margin-right: 4px;
}

.material-color-picker__footer-split {
  width: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  margin: 0 20px 0 14px;
  height: 16px;
}

.material-color-picker__footer-btn svg {
  display: block;
}

.material-bg-remover__indicator {
  transition: 0.15s;
  display: inline-flex;
  align-items: center;
}

.material-bg-remover__indicator .anticon {
  margin-right: 6px;
}

.material-bg-remover__indicator--hidden {
  opacity: 0;
  visibility: hidden;
}

button + .material-bg-remover__indicator {
  margin-left: 16px;
}
</style>